/* eslint-disable jsx-a11y/anchor-is-valid */
import CategoryViewItem from "component/categories-viewer/CategoryViewItem";
import PAText from "component/design-system/typography/PAText/PAText";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import { RootState } from "interfaces/generics.type";
import Link from "next/link";
import { useSelector } from "react-redux";
import { getHrefAndAspath } from "../../../util/url/getHrefAndAspath";
import { getUrlAndQuery } from "../../../util/url/getUrlAndQuery";
import { validateVehicle } from "../../../util/vehicle/validate-vehicle";
import styles from "./styles.module.scss";

function Item({
  cat, index,
}: any) {
  return (
    <>

      <div
        className={`${cat.imageSrcMD === "tires-types.png" ? styles.tires_img_src : styles.wheels_img_src} pointer`}
        style={cat.imageSrcMD === "tires-types.png" ? { backgroundPosition: `${(100 / 10) * index}% 0` } : { backgroundPosition: `${(100 / 4) * index}% 0` }}
      />

      <div className={styles.text}>
        <PAText component="h4">{cat.name}</PAText>
        <Text size={5} className="text-left" type={TEXT_TYPE.secondary}>
          {cat.description}
        </Text>
      </div>
    </>
  );
}

function CategoryGrid(props: any) {
  const { categories, departmentId } = props;

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);

  return (
    <ul className={styles.catTypeGrid}>
      {
        categories.map((cat: any, index) => {
          let child;
          if (validateVehicle(selectedVehicle)) {
            child = (

              <CategoryViewItem
                categoryObj={{
                  tier0: departmentId,
                  tier1: cat.t1,
                  tier2: cat.t2,
                  tier3: cat.t3,
                }}
                defaultFilters={{
                  seasons: cat.seasonFilter || undefined,
                  typeV2s: cat.typeV2Filter,
                  wheelManufacturings: cat.wheelManufacturingFilter,
                }}
              >

                <Item cat={cat} index={index} />
              </CategoryViewItem>
            );
          } else {
            const [url, query = ""] = getUrlAndQuery(cat.canonicalUrl);
            const { asPath } = getHrefAndAspath(undefined, url, query.substring(1));
            child = (
              (
                <Link prefetch={false} href={asPath}>

                  <Item cat={cat} index={index} />

                </Link>
              )
            );
          }
          return (
            <li className={styles.item} key={index}>
              {child}
            </li>
          );
        })
      }
    </ul>
  );
}

export default CategoryGrid;
